import styled from "styled-components";
import {up} from "styled-breakpoints";

export const Wrapper = styled.div`

`